import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "show-if"
    }}>{`Show If`}</h1>
    <p>{`Reforml provides way to decide whether to show a field depending on value of other field`}</p>
    <h2 {...{
      "id": "depend-on-boolean-field"
    }}>{`Depend on boolean field`}</h2>
    <p>{`You can directly supply a field name of boolean field. If that boolean field is true, this field will show.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const handleChange = (newValue) => {
    setValue(newValue)
  }
  const fields = useMemo(() => jsyaml.load(\`
  showHidden:
    type: checkbox
    label: show hidden field
    defaultVal: true
  myText:
    type: text
    label: Input some value
    showIf: showHidden
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={handleChange}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "depend-on-any-field"
    }}>{`Depend on any field`}</h2>
    <p>{`You can directly supply a field name to comparison map to determine whether this field should show.
You may use . to denote value inside a nest field, for example if form value is `}<inlineCode parentName="p">{`{foo: {bar: 1}}`}</inlineCode>{` you can use `}<inlineCode parentName="p">{`{'foo.bar': {$eq: 1}`}</inlineCode>{`.
Here are the list of supported operators:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$eq`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`equal`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$neq`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`not equal`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$gt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`greater than`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$gte`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`greater than or equal`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$lte`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`less than or equal`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$lt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`less than`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$in`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is member of array`}</td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const handleChange = (newValue) => {
    setValue(newValue)
  }
  const fields = useMemo(() => jsyaml.load(\`
  showHiddenIfShow:
    type: text
    label: type show to show the hidden field
    defaultVal: show
  myText:
    type: text
    label: show when showHiddenIfShow is show
    showIf:
      showHiddenIfShow:
        $eq: show
  myText2:
    type: text
    label: Shown when matches any of show's
    showIf:
      showHiddenIfShow:
        $in:
          - show
          - Show
          - sHoW
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={handleChange}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      